import { useAdminClaim } from "../hooks/useAdminClaim";

// Gate for /yard-office. Renders NOTHING for non-admins — no redirect, no 403,
// no loader flash — so the route looks exactly like an unknown path. Because
// the admin page is a lazy() chunk passed in as children, its JS is only
// fetched once the claim is confirmed.
export default function AdminRoute({ children }) {
  const { role, checking } = useAdminClaim();
  if (checking || !role) return null;
  return children;
}
